import React from 'react';
import OrganicTrafficSplineChart from '../OrganicTrafficSplineChart';
import OrganicTrafficBarChart from '../OrganicTrafficBarChart';
import ProductsWithOrganicTrafficSplineChart from '../ProductsWithOrganicTrafficSplineChart';
import KeywordsWithOrganicTrafficSplineChart from '../KeywordsWithOrganicTrafficSplineChart';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';
import OrganicTrafficGrid from '../OrganicTrafficGrid';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import { shouldShowBeaconProTopics } from 'src/utils/app';
import { isTopicOrTopicGroupType } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/utils';
import { TopicOrTopicGroupPage } from './TopicOrTopicGroupPage';
import { NonTopicOrTopicGroupPage } from './NonTopicOrTopicGroupPage';

/**
 * All the visualizations on the organic traffic page
 */
export default function OrganicTrafficPage() {
  const mainEntityType = useMainEntityType();

  if (shouldShowBeaconProTopics() && isTopicOrTopicGroupType(mainEntityType)) {
    return <TopicOrTopicGroupPage />;
  }

  if (shouldShowBeaconProTopics() && !isTopicOrTopicGroupType(mainEntityType)) {
    return <NonTopicOrTopicGroupPage />;
  }

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        <OrganicTrafficSplineChart />
        <OrganicTrafficBarChart />
        {mainEntityType !== 'product' && <ProductsWithOrganicTrafficSplineChart />}
        <KeywordsWithOrganicTrafficSplineChart />
        <OrganicTrafficGrid />
      </Flex>
    </BasePageContainer>
  );
}
